const csvTemplate = `brand_id,sku,month,year,value,value_type
5d3ac303a6992471b7c973c1,API.SC-DCCW1651,1,2022,60,doors
5d3ac303a6992471b7c973c1,API.SC-DCCW1651,2,2022,10,doors
5d3ac303a6992471b7c973c1,API.SC-DCCW1651,3,2022,60,doors
5d3ac303a6992471b7c973c1,API.SC-DCCW1651,4,2022,60,doors
5d3ac303a6992471b7c973c1,API.SC-DCCW1651,5,2022,10,doors
5d3ac303a6992471b7c973c1,API.SC-DCCW1651,6,2022,10,doors
5d3ac303a6992471b7c973c1,API.SC-DCCW1651,7,2022,60,doors
5d3ac303a6992471b7c973c1,API.SC-DCCW1651,8,2022,10,doors
5d3ac303a6992471b7c973c1,API.SC-DCCW1651,9,2022,10,doors
5d3ac303a6992471b7c973c1,API.SC-DCCW1651,10,2022,60,doors
5d3ac303a6992471b7c973c1,API.SC-DCCW1651,11,2022,10,doors
5d3ac303a6992471b7c973c1,API.SC-DCCW1651,12,2022,10,doors
5d3ac302a6992471b7c97360,AW.SC-LPBCT150ALL1,1,2022,60,doors
5d3ac302a6992471b7c97360,AW.SC-LPBCT150ALL1,2,2022,20,doors`;

export default csvTemplate;
